/**
 * In this file use to contains the physician Module Add Vaccination screen UI and Logic
 **/
import React from 'react'
import { Link,useNavigate,useParams } from 'react-router-dom';
import ApiService from './../../services/ApiService';
import * as Yup from 'yup';
import { useState,useEffect, useRef } from 'react';
import { validate } from './../../services/ValidationService';
import { goBack,generateRandomId,calculateAgeWeeks,filterAgeRanges,convertIntToSuffix,convertS3privateToPublic,convertDOBtoAge,formatMeasurement,convertDOBtoMonth,flatPickerFormatDate } from './../../services/UtilsService';
import constantVariables from './../../dataset/constantVariables.json';
import { toast } from 'react-toastify';
import { useSelector } from "react-redux";
import * as moment from 'moment';
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";
import { useTranslation } from 'react-i18next';

const AddVaccination = () => {
	
	//Initial state & variable declaration
	let { id } = useParams();
	const [memberData,setMemberData]=useState([]);
	const [parentData,setParentData]=useState([]);
	const [vaccinationAgeRanges,setVaccinationAgeRanges]=useState([]);
	const [vaccinationName,setvaccinationName]=useState([]);
	const [vaccinationType,setvaccinationType]=useState([]);
	const [vaccinationDose,setvaccinationDose]=useState([]);
	const [vaccinationData,setVaccinationData]=useState([]);
	const [duplicate,setDuplicate]=useState([]);
	const [vacType,setvacType]=useState(false);
	const [error,setError]=useState({});
	const [selectedDose, setSelectedDose] = useState({});
	const navigate = useNavigate();	
	const [isLoading, setIsLoading] = useState(true);
	const masterVaccination = useSelector((state) => state?.vaccination);
	const role = Number(localStorage.getItem('role'));
	const flatpickrRef = useRef(null); // Create a ref for Flatpickr
	const [data, setData] = useState({
		vaccination_date: '',
		age: '',
		vaccination_name: '',
		vaccination_type: '',
		dose: ''
	  });
	  const [allData, setAllData] = useState([{
		vaccination_date: '',
		age: '',
		vaccination_name: '',
		vaccination_type: '',
		dose: '',
		filterDose: [],
		vacType: false,
		vacTypeFilter: []
	  }]);
	const { t } = useTranslation();
	const currentLang = localStorage.getItem('i18nextLng');

	/** 
	* Validation schema for Add Vaccination Fields
	* @vaccination_date - required field and pass the vaccination_date
	* @age - required field and pass the age
	* @vaccination_name - required field and pass the vaccination_name 
	* @dose - required field and pass the dose
	**/
    const fields = [
     { name: 'vaccination_date', validation: Yup.string().required(t('error.required')) },
	 { name: 'age', validation: Yup.string().required(t('error.required'))},
	 { name: 'vaccination_name', validation: Yup.string().required(t('error.required'))},
	 { name: 'vaccination_type', validation: Yup.string() }, // Default validation (conditional)
	 { name: 'dose', validation: Yup.string().required(t('error.required'))}
    ];
	
	//Component Initialize function trigger when request id change
	useEffect(()=>{
		const fetchData = async () => {
			setIsLoading(true); 
			try {
				var response = await ApiService.getMemberProfile(id);
				if(response.status===200){
				 setMemberData({...response.data.item,dobs:convertDOBtoMonth(response.data?.item?.dob)});
				 setParentData(response.data.parentInfo);
				}
				await fetchPatientData(id);
			}catch (error) {
				console.error('Error fetching member data:', error);
			} finally {
				setIsLoading(false); 
			}
		};
		fetchData();
	},[id]);
	
	// This function is used to fetch patient vaccination data
	const fetchPatientData = async (memberId) => {
		try {
			var response = await ApiService.getMemberVaccination({id:memberId});
			if (response.status === 200) {
				setVaccinationData(response?.data?.items);
			} 
		} catch (error) {
			console.error('Error fetching patient development data:', error);
		}
	}
	
   /**
   * To handle input change event in data
   **/
	useEffect(() => {
		(async()=>{			
		if ( data.vaccination_date) {
			if (memberData?.id) {
				const ageInWeeks  = calculateAgeWeeks(memberData?.dob,data.vaccination_date);
				const ageRanges = filterAgeRanges(ageInWeeks,masterVaccination?.vaccinationAge);
				setVaccinationAgeRanges(ageRanges);  
			}
		}
		
		if (data.age){		
			const filterVaccination = masterVaccination?.mapping?.filter((vac) => vac.age <= parseInt(data.age));
			const vaccinationList = masterVaccination?.vaccinationName?.filter((vac) => {
			  return filterVaccination?.some((fil) => vac?.id === fil?.vaccination);
			});
			setvaccinationName(vaccinationList);
			
			const filterVaccinationType = vaccinationName.filter((t) => t.id === parseInt(data.vaccination_name) && t.isHasType === true );
			if(filterVaccinationType.length > 0){
				setvacType(true);
				let filerVaccinationTypeName = masterVaccination?.vaccinationType?.filter((t) => {
					return filterVaccinationType?.some((fil) => t?.vaccineId === fil?.id);
				});		
				// Add a conditional check for data.age === 1 to remove specific items
				if (parseInt(data.age, 10) === 1) {
					filerVaccinationTypeName = filerVaccinationTypeName.filter(item => 
					  !(item.vaccineId === 3 && (item.id === 2 || item.id === 3))
					);
				}
				setvaccinationType(filerVaccinationTypeName);
			} else{
				setvacType(false);
				const filterDose = masterVaccination?.mapping?.filter((t) => t.vaccination === parseInt(data.vaccination_name) && t.age <= data.age );
				setvaccinationDose(filterDose);
			}
		}
		
		if (data.dose){
			const duplicateDiffError =await checkVaccinationDiffDate(data, vaccinationData);
			setDuplicate(duplicateDiffError);
			setError({...error,vaccination_name: duplicateDiffError});
		}
	
		handleDuplicateCheck();
		})();	
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [allData]);

	//This function is used find the duplicate vaccination
		const handleDuplicateCheck = async () => {
			const filteredAllData = allData/* .map(({ filterDose, vacType, vacTypeFilter, ...rest }) => rest) */;
			const rowErrors = {}; // Object to hold errors for each row
			for (let i = 0; i < filteredAllData.length; i++) {
			  const currentData = filteredAllData[i];
			  currentData.vaccination_date = data.vaccination_date;
			  currentData.age = data.age;  
			  // Check for duplicates and other conditions
			  if (currentData.vaccination_name && vaccinationData) {
				// Pass currentData to checkAllDose so it only checks for the current row
				const checkAllVaccinae = await checkAllDose(currentData);
				if (checkAllVaccinae) {
				  // Only add error to the current row if checkAllDose returns true
				  rowErrors[`row_${i}`] = { ...rowErrors[`row_${i}`], vaccination_name: t('common.alreadyVaccinated'), dose: '' };
				}
				const duplicateError = await checkDuplicateVaccination(currentData, vaccinationData);
				setDuplicate(duplicateError);
				const value = duplicateError ? duplicateError[0] : '';
				if (value) {
				  rowErrors[`row_${i}`] = { ...rowErrors[`row_${i}`], vaccination_name: value };
				}
				const duplicateDiffError = await checkVaccinationDiffDate(currentData, vaccinationData);
				if (duplicateDiffError) {
				  rowErrors[`row_${i}`] = { ...rowErrors[`row_${i}`], vaccination_name: duplicateDiffError, dose: '' };
				}
			  }
		  
			  if (currentData.vaccination_name !== "" && currentData.vaccination_type) {
				const checkAllVaccinae = await checkAllDose(currentData); // Pass currentData to checkAllDose
				if (checkAllVaccinae) {
				  rowErrors[`row_${i}`] = { ...rowErrors[`row_${i}`], vaccination_name: t('common.alreadyVaccinated'), dose: '' };
				}
				const duplicateError = await checkDuplicateVaccination(currentData, vaccinationData);
				setDuplicate(duplicateError);
				const value = duplicateError ? duplicateError[0] : '';
				if (value) {
				  rowErrors[`row_${i}`] = { ...rowErrors[`row_${i}`], vaccination_name: value };
				}
		  
				const duplicateDiffError = await checkVaccinationDiffDate(currentData, vaccinationData);
				if (duplicateDiffError) {
				  rowErrors[`row_${i}`] = { ...rowErrors[`row_${i}`], vaccination_name: duplicateDiffError, dose: '' };
				}
			  }
			}
			// Set the errors state with all row-specific errors
			setError(rowErrors);
		  };
		  
	
		//To check all doses are patient putting or not
		const checkAllDose = (currentData) => {
			// Filter latest vaccinations based on filterDose criteria
			const latestVaccination = vaccinationData?.filter((t) => 
				currentData.filterDose?.some((fil) => t?.vaccination === fil?.vaccination)
			);
		
			// Filter current doses matching the filterDose criteria
			const currentDosesVaccine = masterVaccination.mapping.filter(mapping => 
				currentData.filterDose.some(dose => 
					dose.age === mapping.age && dose.vaccination === mapping.vaccination
				)
			);
		
			// Group doses by age
			const groupedDoses = currentDosesVaccine.reduce((acc, item) => {
				const ageKey = `age_${item.age}`;
				if (!acc[ageKey]) acc[ageKey] = [];
				acc[ageKey].push(item);
				return acc;
			}, {});
		
			// Find unmatched age groups
			const unmatchedAges = Object.keys(groupedDoses).filter((ageKey) => {
				const group = groupedDoses[ageKey];
				return !group.some((groupItem) => 
					latestVaccination.some((latest) => 
						latest.vaccination === groupItem.vaccination &&
						latest.type === groupItem.type &&
						latest.dose === groupItem.dose
					)
				);
			}).map((ageKey) => parseInt(ageKey.split('_')[1], 10));
			// Return false if vacType is not selected for typed vaccinations
			if (currentData.vacType === true && currentData.vaccination_type === ''){
				return false;
			}
			// Return true if all groups are matched, false otherwise
			return unmatchedAges.length === 0;
		};		
		  
		  
	const handleAdd = async (index) => {
		// Check if there are any errors
		if (Object.keys(error).length > 0) {
			return;
		}
		// Step 1: Initialize error states
		let hasErrors = false;
		let globalErrors = {}; // To hold errors for `age` and `vaccination_date`
		let rowErrors = {}; // To hold errors for the current row
		// Step 2: Validate global fields (only `age` and `vaccination_date`)
		if (!data.age) {
			hasErrors = true;
			globalErrors.age = t('error.required');
		}
		if (!data.vaccination_date) {
			hasErrors = true;
			globalErrors.vaccination_date = t('error.required');
		}

		// Step 3: Validate row-specific fields
		const dynamicFields = fields.map((field) => {
			if (field.name === "vaccination_type" && allData[index].vacType === true) {
				// Make `vaccination_type` required only when `vacType` is true
				return { ...field, validation: Yup.string().required(constantVariables.error.required) };
			}
			return field; // Keep existing validation for other fields
		});
		allData[index].age= data.age;
		allData[index].vaccination_date= data.vaccination_date;
		const Errors = await validate(allData[index], dynamicFields);
		// If there are errors, assign them to row-specific errors
		if (Object.keys(Errors).length > 0) {
			hasErrors = true;
			rowErrors[`row_${index}`] = Errors; // Assign errors to the specific index
		}
		// Step 4: Combine global and row-specific errors
		const errorMapping = { ...error, ...globalErrors, ...rowErrors };

		// Step 5: Set errors and exit if validation fails
		if (hasErrors) {
			setError(errorMapping); // Update error state
			return; // Stop further processing
		}
	  
		// Check if there are no validation errors for the current row
		if (Object.keys(Errors).length === 0) {
			  setAllData((prevAllData) => {
				const updatedAllData = [...prevAllData];
	
				// Check if the current index is the last index
				if (index !== prevAllData.length - 1) {
					// Ensure each entry includes the common data fields
					const commonData = {
						vaccination_date: data.vaccination_date || prevAllData[0]?.vaccination_date || '',
						age: data.age || prevAllData[0]?.age || '',
					};
	
					// Dynamically create the dose key based on the index (e.g., dose_0, dose_1)
					const doseKey = `dose_${index}`;
	
					updatedAllData[index] = {
						...commonData,
						vaccination_name: data.vaccination_name,
						vaccination_type: data.vaccination_type,
						dose: data[doseKey] || data.dose || '', // Update dose dynamically based on dose_0, dose_1, etc.
						filterDose: prevAllData[index]?.filterDose || [], // Maintain filterDose
						vacType: prevAllData[index]?.vacType || false, // Maintain vacType
						vacTypeFilter: prevAllData[index]?.vacTypeFilter || [], // Maintain vacTypeFilter
					};
				}
	
				// Add a new entry at the next index with default values if it doesn't exist
				if (!updatedAllData[index + 1]) {
					updatedAllData.push({
						vaccination_name: '',
						vaccination_type: '',
						dose: '',
						vaccination_date: data.vaccination_date || '',
						age: data.age || '',
						filterDose: [], // Default value for new entry
						vacType: false, // Default value for new entry
						vacTypeFilter: [], // Default value for new entry
					});
				}
	
				return updatedAllData;
			}); 
		  // Reset only the vaccination fields in the data object
		  setData({
			vaccination_name: '',
			vaccination_type: '',
			dose: '',
			vaccination_date: data.vaccination_date, // Retain vaccination_date
			age: data.age, // Retain age,
		  });
		}
	};		
	
	const handleRemove = (index) => {
		// Remove the row from allData
		const updatedAllData = allData.filter((_, i) => i !== index);
		setAllData(updatedAllData);
		// Remove the key corresponding to the index in selectedDose
		const updatedSelectedDose = { ...selectedDose };
		delete updatedSelectedDose[index];
		// Reorder the keys in selectedDose to ensure sequential indexing
		const reorderedSelectedDose = Object.keys(updatedSelectedDose)
			.sort((a, b) => a - b) // Sort keys numerically
			.reduce((acc, key, idx) => {
				acc[idx] = updatedSelectedDose[key]; // Reassign value with new key
				return acc;
			}, {});
		// Update the selectedDose state
		setSelectedDose(reorderedSelectedDose);
		// Create a shallow copy of the error object
		const updatedError = { ...error };
		// Delete the specific row error (row_index) corresponding to the removed index
		delete updatedError[`row_${index}`];
		// Update the error state
		setError(updatedError);
	};
	
	  
	  const getAvailableVaccinationNames = (currentIndex) => {
		const selectedIds = allData
			.map((vaccination, index) => 
				index !== currentIndex ? Number(vaccination.vaccination_name) : null
			)
			.filter(id => id !== null); // Ensure no null values in selectedIds
	
		return vaccinationName.filter(item => !selectedIds.includes(item.id));
	};

	/** 
    * To handle input change event 
    * @e - we get the event details from the Change action
    **/
	const handleChange = async(e, index) => {
	    const {name,value}=e.target;
		// e.preventDefault();
		if(name==='vaccination_date'){
			setData({...data,vaccination_date:value,age:'',vaccination_name:'',vaccination_type:'',dose:''});
			setSelectedDose({});
			setvaccinationName([]);
			setAllData([{vaccination_date: '',age: '',vaccination_name: '',vaccination_type: '',dose: '',filterDose: [],
				vacType: false,
				vacTypeFilter: []}]);
			if (memberData) {
				const ageInWeeks  = calculateAgeWeeks(memberData?.dob,value);
				const ageRanges = filterAgeRanges(ageInWeeks,masterVaccination?.vaccinationAge);
				setVaccinationAgeRanges(ageRanges);
			}
			if (!data.dose) {
				setError({ ...error, dose: '',vaccination_date:'' });
				return; 
			}
		}else if(name==='age'){
			setData({...data,age:value,vaccination_name:'',vaccination_type:'',dose:''});
			setSelectedDose({});
			setAllData([{vaccination_date: '',age: '',vaccination_name: '',vaccination_type: '',dose: '',filterDose: [],
				vacType: false,
				vacTypeFilter: []}]);
			const filterVaccination = masterVaccination?.mapping?.filter((vac) => vac.age <= parseInt(value));
			const vaccinationList = masterVaccination?.vaccinationName?.filter((vac) => {
			  return filterVaccination?.some((fil) => vac?.id === fil?.vaccination);
			});
			
			setvaccinationName(vaccinationList);
			if (!data.dose) {
				setError({ ...error, dose: '',vaccination_date:'' });
				return; 
			}
		}else if (name==='vaccination_name'){
			setData({...data,vaccination_name:value,vaccination_type:'',dose:''});
			//setSelectedDose('');
			// Remove dose selection for the specific index
			index !== null && index >= 0 && setSelectedDose(prevSelectedDose => {
				const updatedSelectedDose = { ...prevSelectedDose }; // Create a copy of the previous state
				delete updatedSelectedDose[index]; // Delete the entry for the specific index
				return updatedSelectedDose; // Return the updated object
			});
			// Use the index to update the allData array dose value to '' empty
			setAllData((prevAllData) => {
				return prevAllData.map((item, idx) => {
				  if (idx === index) {
					return { ...item, dose: '' }; // Update dose to an empty string
				  }
				  return item; // Return other items as-is
				});
			  });
			const filterVaccinationType = vaccinationName.filter((t) => t.id === parseInt(value) && t.isHasType === true );
			if(filterVaccinationType.length > 0){
				setvacType(true);
				let filerVaccinationTypeName = masterVaccination?.vaccinationType?.filter((t) => {
					return filterVaccinationType?.some((fil) => t?.vaccineId === fil?.id);
				});				
				// Add a conditional check for data.age === 1 to remove specific items
				if (parseInt(data.age, 10) === 1) {
					filerVaccinationTypeName = filerVaccinationTypeName.filter(item => 
					  !(item.vaccineId === 3 && (item.id === 2 || item.id === 3))
					);
				}
				setvaccinationType(filerVaccinationTypeName);
				
					if (index !== null && index >= 0) {
						setAllData((prevAllData) => {
							const updatedAllData = [...prevAllData];
							
							// Check if the name starts with 'dose_' (e.g., dose_0, dose_1, etc.)
							if (name.startsWith('dose_')) {
								updatedAllData[index] = {
									...updatedAllData[index], // Keep existing data at the index
									dose: data.dose, // Update the dose field for dose_* name
									vacType: true,
									vacTypeFilter: filerVaccinationTypeName, // Keep existing update logic
								};
							} else {
								// Default update logic for other fields
								updatedAllData[index] = {
									...updatedAllData[index], // Keep existing data at the index
									vacType: true,
									vaccination_type: '',
									vacTypeFilter: filerVaccinationTypeName, // Update the specific field with new value
								};
							}
							return updatedAllData;
						});
					}
					
			} else{
				setvacType(false);
				const filterDose = masterVaccination?.mapping?.filter((t) => t.vaccination === parseInt(value) && t.age <= data.age );
				setvaccinationDose(filterDose);
				
					if (index !== null && index >= 0) {
						setAllData((prevAllData) => {
							const updatedAllData = [...prevAllData];
							
							// Check if the name starts with 'dose_' (e.g., dose_0, dose_1, etc.)
							if (name.startsWith('dose_')) {
								updatedAllData[index] = {
									...updatedAllData[index], // Keep existing data at the index
									dose: data.dose, // Update the dose field for dose_* name
									vacType: false,
									filterDose: filterDose, // Update the specific field with new value
								};
							} else {
								// Default update logic for other fields
								updatedAllData[index] = {
									...updatedAllData[index], // Keep existing data at the index
									vacType: false,
									filterDose: filterDose, // Update the specific field with new value
								};
							}
					
							return updatedAllData;
						});
					}
					
			}
			//setError({...error,vaccination_name:'',dose:''});
		} else if (name==='vaccination_type'){
			setData({...data,vaccination_type:value});
			//setSelectedDose('');
			// Remove dose selection for the specific index
			index !== null && index >= 0 && setSelectedDose(prevSelectedDose => {
				const updatedSelectedDose = { ...prevSelectedDose }; // Create a copy of the previous state
				delete updatedSelectedDose[index]; // Delete the entry for the specific index
				return updatedSelectedDose; // Return the updated object
			});
			// Use the index to update the allData array dose value to '' empty
			setAllData((prevAllData) => {
				return prevAllData.map((item, idx) => {
				  if (idx === index) {
					return { ...item, dose: '' }; // Update dose to an empty string
				  }
				  return item; // Return other items as-is
				});
			});
			/* const filterTypeDose = masterVaccination?.mapping?.filter((vac) => {
			  return vaccinationType?.some((fil) => vac?.vaccination === fil?.vaccineId && fil?.id === vac?.type && vac.age <= data.age );
			});
			const filterUniqueType = filterTypeDose.filter((item) => item?.type ===  parseInt(value) ); */
			// Compare arrays by the "id" value
			const areArraysEqualById = (arr1, arr2) => {
				if (arr1.length !== arr2.length) return false;
				// Compare by id value
				return arr1.every((obj1) =>
				arr2.some((obj2) => obj1.id === obj2.id)
				);
			};
			// Check if vacTypeFilter and vaccinationType arrays have the same "id" values
			const useVaccinationType = areArraysEqualById(allData[index].vacTypeFilter, vaccinationType);
			// Use the appropriate array based on the comparison
			const filterTypeDose = masterVaccination?.mapping?.filter((vac) => {
				return (useVaccinationType ? vaccinationType : allData[index].vacTypeFilter)?.some((fil) => 
				vac?.vaccination === fil?.vaccineId && fil?.id === vac?.type && vac.age <= data.age
				);
			});
			const filterUniqueType = filterTypeDose.filter((item) => item?.type === parseInt(value));
			setvaccinationDose(filterUniqueType);
			
				if (index !== null && index >= 0) {
					setAllData((prevAllData) => {
						const updatedAllData = [...prevAllData];
						// Check if the name starts with 'dose_' (e.g., dose_0, dose_1)
						if (name.startsWith('dose_')) {
							updatedAllData[index] = {
								...updatedAllData[index], // Keep existing data at the index
								dose: data.dose, // Update the 'dose' field for dose_* name
							};
						} else {
							updatedAllData[index] = {
								...updatedAllData[index], // Keep existing data at the index
								filterDose: filterUniqueType, // Update the 'filterDose' field for other names
							};
						}
						return updatedAllData;
					});
				}
				
		}else{
			setData({...data,[name]:value});
		}

		if (index !== undefined) {
			// Initialize error states for this row
			let hasErrors = false;
			let globalErrors = {}; // To hold errors for `age` and `vaccination_date`
			let rowErrors = {}; // To hold errors for the current row
		
			// Step 1: Validate global fields (only `age` and `vaccination_date`)
			if (!data?.age) {
				hasErrors = true;
				globalErrors.age = t('error.required');
			}
			if (!data?.vaccination_date) {
				hasErrors = true;
				globalErrors.vaccination_date = t('error.required');
			}
		
			// Step 2: Validate row-specific fields
			const currentRow = allData[index]; // Get the current row data
			const dynamicFields = fields.map((field) => {
				if (field.name === "vaccination_type" && currentRow.vacType === true) {
					// Make `vaccination_type` required only when `vacType` is true
					return { ...field, validation: Yup.string().required(constantVariables.error.required) };
				}
				return field; // Keep existing validation for other fields
			});
		
			const Errors = await validate({ [name]: value }, dynamicFields);
		
			// If there are errors, assign them to row-specific errors
			if (Object.keys(Errors).length > 0) {
				hasErrors = true;
				rowErrors[`row_${index}`] = { ...error[`row_${index}`], [name]: Errors[name] }; // Merge with existing row errors
			}
			// Step 3: Combine global and row-specific errors
			const errorMapping = { ...error, ...globalErrors, ...rowErrors };
			// Step 4: Set errors
			setError(errorMapping);
		} else {
			const Errors=await validate({[name]:value},fields);
			setError({...error,[name]:Errors[name]});
		}
		
		 // Update `allData` if index is provided (not null)
			if (index !== null && index >= 0) {
				setAllData((prevAllData) => {
					const updatedAllData = [...prevAllData];
			
					// Check if the name starts with 'dose_' (e.g., dose_0, dose_1)
					if (name.startsWith('dose_')) {
						updatedAllData[index] = {
							...updatedAllData[index], // Keep existing data at the index
							dose: value, // Update the 'dose' field for dose_* name
						};
					} else {
						updatedAllData[index] = {
							...updatedAllData[index], // Keep existing data at the index
							[name]: value, // Update other fields with their specific values
						};
					}
			
					return updatedAllData;
				});
			}
			
	};
	
	//This function is used convaert utc to date
	function convertToDate (dateTimeString){
		const formattedDate = moment(dateTimeString).format('YYYY-MM-DD');
		return formattedDate;
	}
	
	//This function is used to check the duplicate vaccaintion 
	const checkDuplicateVaccination = (data, vaccinationData) => {
		const duplicates  = vaccinationData.filter((vac) => convertToDate(vac.vaccination_date) >= data.vaccination_date && vac.vaccination === parseInt(data.vaccination_name) && 
			(parseInt(data.vaccination_type) ? vac.type === parseInt(data.vaccination_type) : true)
		);
		
		if (duplicates.length > 0) {
			const errorMessages = duplicates.map((duplicate) => {
				const vaccination = masterVaccination?.vaccinationName?.find(
					(vac) => vac.id === duplicate.vaccination
				);
				const vaccinationName = currentLang === 'ta' ? vaccination?.name_tamil : vaccination?.name;

				const dose = duplicate.dose === 5 ? 'B1' : duplicate.dose === 6 ? 'B2' : duplicate.dose === 0 ? 'Birth' : duplicate.dose +""+convertIntToSuffix(duplicate.dose);
				const formattedDate = convertToDate(duplicate.vaccination_date);
				if (currentLang === 'ta') {
					return `${vaccinationName || 'Vaccination'}, ${dose} ${t('common.dose')} ${t('common.already')} ${formattedDate} ${t('common.added')} . ${t('common.selectValidDate')}`;
				}else {
					return `${vaccinationName || 'Vaccination'}, ${dose} dose is already added on ${formattedDate}. Please select valid date`;
				}
			});
			return errorMessages;
		}
		
		const duplicatesHandlePolio  = vaccinationData.filter((vac) => convertToDate(vac.vaccination_date) >= data.vaccination_date && vac.vaccination === parseInt(data.vaccination_name)
		);
		
		if (duplicatesHandlePolio.length > 0) {
			const errorMessages = duplicatesHandlePolio.map((duplicate) => {
				const vaccination = masterVaccination?.vaccinationName?.find(
					(vac) => vac.id === duplicate.vaccination
				)?.name;
				const vaccinationName = currentLang === 'ta' ? vaccination?.name_tamil : vaccination?.name;

				const dose = duplicate.dose === 5 ? 'B1' : duplicate.dose === 6 ? 'B2' : duplicate.dose === 0 ? 'Birth' : duplicate.dose +""+convertIntToSuffix(duplicate.dose);
				const formattedDate = convertToDate(duplicate.vaccination_date);
				if (currentLang === 'ta') {
					return `${vaccinationName || t('sidebar.vaccination')}, ${dose} ${t('common.dose')} ${t('common.already')} ${formattedDate} ${t('common.added')} . ${t('common.selectValidDate')}`;
				}else {
					return `${vaccinationName || t('sidebar.vaccination')}, ${dose} dose is already added on ${formattedDate}. Please select valid date`;
				}
			});
			return errorMessages;
		}
		
		//To check the maximum child age only allowed vaccination
		const duplicateChildAge = vaccinationData.filter((vac) => {
			const vaccinationName = data?.vaccination_name;
			const age = data?.age;
			return (vaccinationName && parseInt(vaccinationName) === vac.vaccination) &&
				vac.child_age > parseInt(age);
		});
		
		if(duplicateChildAge.length >0 ){
			const errorMessages = duplicateChildAge.map((duplicate) => {
				const vaccination = masterVaccination?.vaccinationName?.find(
					(vac) => vac.id === duplicate.vaccination
				);
				const vaccinationName = currentLang === 'ta' ? vaccination?.name_tamil : vaccination?.name;

				const dose = duplicate.dose === 5 ? 'B1' : duplicate.dose === 6 ? 'B2' : duplicate.dose === 0 ? t('common.birth') : duplicate.dose +""+convertIntToSuffix(duplicate.dose);
				const ageData = masterVaccination?.vaccinationAge?.find(
					(vac) => vac.id === parseInt(duplicate.child_age)
				);
				const vaccinationAge = currentLang === 'ta' ? ageData?.name_tamil : ageData?.name;
				if (currentLang === 'ta') {
					return `${vaccinationName || 'Vaccination'}, ${dose} ${t('common.dose')} ${vaccinationAge} ${t('common.added_on')}. ${t('common.selectValidAge')} `;
				} else {
					return `${vaccinationName || 'Vaccination'}, ${dose} dose is added on ${vaccinationAge}. Please select valid Age.`;
				}
			});
			return errorMessages;
		}
		return null; 
	};
	
	//This function is used to check the duplicate vaccaintion on different date
	const checkVaccinationDiffDate = async(data, vaccinationData) => {
		const duplicatesDiffDate  =await vaccinationData.filter((vac) => vac.vaccination === parseInt(data.vaccination_name) && vac.dose === parseInt(data.dose) &&
			(parseInt(data.vaccination_type) ? vac.type === parseInt(data.vaccination_type) : true)
		);
		
		if(duplicatesDiffDate.length >0){
			return t('common.alreadyVaccinated');
		}
		return '';
	}
	
	/** 
   * To handle dose input change event 
   * @e - we get the event details from the Change action
   **/
    const handleDoseChange = async (e,item,index) => {
		const {name,value}=e.target;
		/* 		setData({ ...data, [name]: value});  */
		if (name.startsWith('dose_')) {
			setData({ ...data, dose: value });  // Update 'dose' field for 'dose_*'
		} else {
			setData({ ...data, [name]: value });  // Update other fields
		}

			if (index !== null && index >= 0) {
				setAllData((prevAllData) => {
					const updatedAllData = [...prevAllData];
					
					// Check if the name is a dose_* field (like dose_0, dose_1)
					if (name.startsWith('dose_')) {
						// Update the 'dose' field specifically for dose_* fields
						updatedAllData[index] = {
							...updatedAllData[index], // Keep existing data at the index
							dose: value, // Only update the 'dose' field with the value
						};
					} else {
						// Update the specific field with its value
						updatedAllData[index] = {
							...updatedAllData[index], // Keep existing data at the index
							[name]: value, // Update the field matching 'name' with the value
						};
					}
			
					return updatedAllData;
				});
			}			
		// await setSelectedDose(value); 
		setSelectedDose((prevSelectedDose) => ({
			...prevSelectedDose,  // Retain previous values
			[index]: value,       // Update the specific row's selected dose
		}));		
		if(duplicate === null){
			setError({...error,vaccination_name:''});
		}
		if (index !== null && index >= 0) {
			// Initialize error states for this row
			let hasErrors = false;
			let globalErrors = {}; // To hold errors for `age` and `vaccination_date`
			let rowErrors = {}; // To hold errors for the current row
			// Step 1: Validate global fields (only `age` and `vaccination_date`)
			if (!data?.age) {
				hasErrors = true;
				globalErrors.age = t('error.required');
			}
			if (!data?.vaccination_date) {
				hasErrors = true;
				globalErrors.vaccination_date = t('error.required');
			}
			// Step 2: Validate row-specific fields
			const currentRow = allData[index]; // Get the current row data
			const dynamicFields = fields.map((field) => {
				if (field.name === "vaccination_type" && currentRow.vacType === true) {
					// Make `vaccination_type` required only when `vacType` is true
					return { ...field, validation: Yup.string().required(constantVariables.error.required) };
				}
				return field; // Keep existing validation for other fields
			});
			const Errors = await validate({ [name]: value }, dynamicFields);
			// If there are errors, assign them to row-specific errors
			if (Object.keys(Errors).length > 0) {
				hasErrors = true;
				rowErrors[`row_${index}`] = { ...error[`row_${index}`], [name]: Errors[name] }; // Merge with existing row errors
			}
			// Step 3: Combine global and row-specific errors
			const errorMapping = { ...error, ...globalErrors, ...rowErrors };
			// Step 4: Set errors
			setError(errorMapping);
		} else {
			const Errors=await validate({[name]:value},fields);
			setError({...error,[name]:Errors[name]});
		}
	}
	
	
	/** 
   * To handle the form submit event 
   * @e - we get the event details from the form submit action
   **/	
	const handleSubmit = async (e) => {
		e.preventDefault();
		/* await updateAllDataWithAgeAndDate(); */
		// Filter out undefined values from the error object
		const filteredError = Object.fromEntries(
			Object.entries(error).filter(([key, value]) => value !== undefined)
		);
		// Check if there are any remaining errors
		if (Object.keys(filteredError).length > 0) {
			return;
		}
		// Step 1: Create `filteredAllData` to remove unnecessary fields
		const filteredAllData = allData/* .map(({ filterDose, vacType, vacTypeFilter, ...rest }) => rest) */;
		// Step 2: Initialize error states
		let hasErrors = false;
		let globalErrors = {}; // To hold errors for `age` and `vaccination_date`
		let rowErrors = {}; // To hold errors for rows (`row_0`, `row_1`, etc.)
		// Step 3: Validate global fields (only `age` and `vaccination_date`)
		if (!data?.age) {
			hasErrors = true;
			globalErrors.age = t('error.required');
		}
		if (!data?.vaccination_date) {
			hasErrors = true;
			globalErrors.vaccination_date = t('error.required');
		}
		// Step 4: Validate row-specific fields
		for (let i = 0; i < filteredAllData.length; i++) {
			let currentData = filteredAllData[i];
			currentData.age = data.age;
			currentData.vaccination_date = data.vaccination_date;
				// Dynamically adjust the validation schema based on `vacType`
				const dynamicFields = fields.map(field => {
					if (field.name === "vaccination_type" && allData[i].vacType === true) {
						// Make `vaccination_type` required only when `vacType` is true
						return { ...field, validation: Yup.string().required(constantVariables.error.required) };
					}
					return field; // Keep existing validation for other fields
				});
				// Validate the current row
				const Errors = await validate(currentData, dynamicFields);
				// Add row-specific errors to `rowErrors`
				if (Object.keys(Errors).length > 0) {
					hasErrors = true;
					rowErrors[`row_${i}`] = Errors; // Assign errors to the specific index
				}
			}
			// Step 5: Combine global and row-specific errors
			const errorMapping = { ...globalErrors, ...rowErrors };

			// Step 6: Set errors and exit if validation fails
			if (hasErrors) {
				setError(errorMapping); // Update error state
				return; // Stop further processing
			}
		// Step 7: Proceed with API calls (unchanged from your existing logic)
		let successCount = 0;
	
		for (let i = 0; i < filteredAllData.length; i++) {
			let currentData = filteredAllData[i];
			currentData.vaccination_date = data.vaccination_date;
			currentData.age = data.age;  
			const checkAllVaccinae = await checkAllDose(currentData);
	
			if (checkAllVaccinae) {
				setError((prev) => ({
					...prev,
					[`row_${i}`]: { vaccination_name: t('common.alreadyVaccinated'), dose: "" },
				}));
				return; // Stop further processing
			}

			const duplicateDiffError = await checkVaccinationDiffDate(currentData, vaccinationData);
			const duplicateError = await checkDuplicateVaccination(currentData, vaccinationData);
	
			if (duplicateError) {
				setError((prev) => ({
					...prev,
					[`row_${i}`]: { vaccination_name: duplicateError[0] },
				}));
				toast.error("Duplicate vaccination detected");
				return; // Stop further processing
			} else if (duplicateDiffError) {
				setError((prev) => ({
					...prev,
					[`row_${i}`]: { vaccination_name: duplicateDiffError, dose: "" },
				}));
				toast.error("Vaccination date conflicts");
				return; // Stop further processing
			}

			// Prepare data for API call
			currentData.id = generateRandomId();
			currentData.child_age = currentData.age;
			currentData.vaccination = currentData.vaccination_name;
			currentData.type = currentData.vaccination_type ? currentData.vaccination_type : 0;
			// currentData.masterId = currentData.vaccination_name;
			currentData.masterId = currentData.filterDose?.[0]?.vaccineId || null;
			currentData.parentId = memberData?.parent;
			currentData.member = memberData?.id;
			// Check if vacType is false and update the object accordingly
			if (currentData.vacType === false) {
				currentData = {
					...currentData, // Spread the existing data
					vacTypeFilter: [], // Set vacTypeFilter to an empty array
					vaccination_type: "", // Set vaccination_type to an empty string
					type: 0,
				};
			}
			const response = await ApiService.createVaccination(currentData);
			if (response.status === 200) {
				successCount++;
			} else {
				toast.error(response?.data?.message);
				return; // Stop further processing
			}
		}
	
		// Step 8: Show success response only if all API calls were successful
		if (successCount === filteredAllData.length) {
			toast.success("Vaccination created successfully");
			if (role === 4) {
				navigate("/hospital/admin/children");
			} else {
				navigate("/physician/vaccination");
			}
		}
	};			 

    //To handle the form reset
	const handleCancel =() => {
		setData({});
		setAllData([{vaccination_date: '',age: '',vaccination_name: '',vaccination_type: '',dose: '',filterDose: [],
			vacType: false,
			vacTypeFilter: []}]);
		setError({});
		setVaccinationAgeRanges([]);
		setvaccinationName([]);
		setvaccinationType([]);
		setvaccinationDose([]);
		setSelectedDose({});
		
	}
	
	// Dynamically render radio buttons based on vaccination doses
	const renderRadioButtons = (indexVal) => {
		// Determine the source for vaccinationDose
		const doseData = indexVal !== undefined && indexVal >= 0 ? allData[indexVal]?.filterDose : vaccinationDose;
		if (doseData && doseData.length > 0) {
			const latestVaccination = vaccinationData?.filter((t) => {
				return doseData?.some((fil) => t?.vaccination === fil?.vaccination );
			});
			// Filter based on age and vaccination
			const currentDosesVaccine = masterVaccination.mapping.filter(mapping => {
				return doseData.some(dose => {
					return dose.age === mapping.age && dose.vaccination === mapping.vaccination;
				});
			});
			
			const groupedDoses = currentDosesVaccine.reduce((acc, item) => {
				const ageKey = `age_${item.age}`;
				if (!acc[ageKey]) {
					acc[ageKey] = [];
				}
				acc[ageKey].push(item);
				return acc;
			}, {});
			//Find unmatched age groups
			const unmatchedAges = Object.keys(groupedDoses).filter((ageKey) => {
				const group = groupedDoses[ageKey];
				return !group.some((groupItem) => 
					latestVaccination.some((latest) => 
						latest.vaccination === groupItem.vaccination &&
						latest.type === groupItem.type &&
						latest.dose === groupItem.dose
					)
				);
			}).map((ageKey) => parseInt(ageKey.split('_')[1], 10));
			const minUnmatchedAge = unmatchedAges.length > 0 ? Math.min(...unmatchedAges) : null;

			return doseData.map((dose, index) => (			
				<div key={index} className="form-check form-check-inline">
					<input
						className={`form-check-input ${role === 4 ? 'admin-form-check-input' : ''}`}
						type="radio"
						/* name="dose" */
						name={`dose_${indexVal}`} // Make the name unique for each row
						onChange={(e)=>handleDoseChange(e,dose.dose,indexVal)}
						id={`DoseRadio${index + 1}`}
						value={dose.dose} // Set value to dose number
						checked={selectedDose[indexVal] === dose.dose.toString()}  // Check based on the row index
						disabled={dose.age !== minUnmatchedAge}
					/>
					<label className="form-check-label" htmlFor={`DoseRadio${index + 1}`}>
						{dose.dose === 5 ? 'B1' : dose.dose === 6 ? 'B2' : dose.dose}{dose.dose === 5 ? '' :dose.dose === 6 ? '' : convertIntToSuffix(dose.dose)}
					</label>
				</div>
			));
		}else {
			// Render default set of radio buttons from 0th to 4th dose
			return [...Array(5).keys()].map((index) => (
				<div key={index} className="form-check form-check-inline">
					<input
						className={`form-check-input ${role === 4 ? 'admin-form-check-input' : ''}`}
						type="radio"
						name="dose"
						//onChange={(e)=>handleDoseChange(e,`option${index + 1}`)}
						id={`DoseRadio${index + 1}`}
						value={`option${index + 1}`} // Set value to option index
						disabled={true}
					/>
					<label className="form-check-label" htmlFor={`DoseRadio${index + 1}`}>
						{index}th
					</label>
				</div>
			));
		}
	};

	//Bind the age value
	const getLocalizedAge = (age) => {
		if (currentLang === 'ta') {
			return age.name_tamil || age.name; // fallback if tamil not present
		}
		return age.name;
	};

	//Bind the vaccination value
	const getLocalizedName = (vaccination) => {
		if (currentLang === 'ta') {
			return vaccination.name_tamil || vaccination.name; // fallback if tamil not present
		}
		return vaccination.name;
	};

	//Bind the vaccination type
	const getLocalizedType = (type) => {
		if (currentLang === 'ta') {
			return type.name_tamil || type.name; // fallback if tamil not present
		}
		return type.name;
	};
	
	return (
	<main id="main" className="main">
		{/* Page Title Section */}
		<div className="pagetitle clearfix">
			<div className="float-start">
			  <h1>{t('common.addVaccination')}</h1>
				<nav>
					<ol className="breadcrumb">
					  <li className="breadcrumb-item"><Link to={role===4 ? '/hospital/admin/dashboard' : '/physician/dashboard'}>{t('sidebar.home')}</Link></li>
					  <li className="breadcrumb-item active">{t('common.addVaccination')} </li>
					</ol>
				</nav>
			</div>
			<div className="float-end mt-2 me-1">
				<span onClick={goBack} className="backIcon"><i className="iconly-Bold-ArrowLeftSquare"></i></span>
			</div>{/* End Buttons */}
		</div>
		{/* End Page Title Section */}
		{/* Page Content Section */}
		<section className="pagesection">
			<div className="row">
				<div className="col-xxl-12">
					<form className="form-card p-2">
					{/* Patient(kids) Info */}
					{!isLoading &&
					<>
					<div className="row">				
						<div className={memberData?.gender === 0 ? "male col-lg-12" : "female col-lg-12"}>
							<div className="d-md-flex align-items-center ps-1">
								<div className="avtar-img">
									<span className="rounded-circle">
									{memberData?.photo==='default.png'?<img src="/assets/img/user-avatar.png" alt="UN" />:<img src={convertS3privateToPublic(memberData?.photo)} alt="UN" />}
									</span>
								</div>
								<div className="ms-lg-2">
									<Link to={role === 4 ? '/hospital/admin/view-children/' + memberData?.id : '/physician/member-profile/' + memberData?.id}><h5 className="table-title fw-bold">{memberData?.name ? memberData?.name : '--'}</h5></Link>
									<p className={`table-subtitle ${role === 4 ? 'admin-table-subtitle' : ''}`}><span>{memberData.gender === 0? t('common.boy') :  t('common.girl')}</span>{" "} - {convertDOBtoAge(memberData.dob, t)}</p>
								</div>
								<div className="ms-lg-5">
									<p className="mb-0 small">{t('sidebar.parent')}</p>
									<p className="mb-0 table-subtitle">{parentData?.first_name+' '+parentData?.last_name}</p>
								</div>
								<div className="ms-lg-5">
									<p className="mb-0 small">{t('table.bloodGroup')}</p>
									<p className="mb-0 table-subtitle">{memberData?.blood_group ? memberData?.blood_group+' ve' : '--'}</p>
								</div>
								<div className="ms-lg-5">
									<p className="mb-0 small">{t('table.weight')} / {t('table.height')}</p>
										{/*<p className="mb-0 table-subtitle">8.5 kg / 71.0 cm</p>*/}
									<p className="mb-0 table-subtitle">
									{memberData.latest_weight && memberData.latest_weight !== '0' ?`${formatMeasurement(memberData.latest_weight)} ${t('common.kg')}`	: '--'}
									<span className="mx-2" style={{color:'black'}}>/</span> {memberData?.latest_height && memberData.latest_height!== '0' ? `${formatMeasurement(memberData.latest_height)} ${t('common.cm')}`	: '--'}
									</p>
								</div>
							</div>
						</div>	
					</div>	
					<hr className="my-3"/>	
					</>}
					{ /* Patient Kids Info section end */}
						<div className="row">					
							<div className={`col-lg-4 col-md-6 ${
								role === 4  ? 'admin-flatpicker' : 'flatpicker'
							}`}>
								<div className=" form-group">
									<label>{t('common.vaccinationDate')}</label>
									{/* <input name="vaccination_date" min={memberData?.dob}  max={new Date().toISOString().split('T')[0]} value={data.vaccination_date||''} type="date" className={`form-control ${role === 4 ? 'admin-date-input' : ''}`} onChange={handleChange} /> */}
									<div className="input-group">
										<Flatpickr
										value={data.vaccination_date || ""}
										name="vaccination_date"
										onChange={(selectedDates) => {
											const selectedDate = selectedDates[0]; // Get the selected date
											if (selectedDate) {
											// Format the date as 'YYYY-MM-DD'
											const formattedDate = flatPickerFormatDate(selectedDate);
												handleChange({
													target: {
														name: "vaccination_date",
														value: formattedDate, // Format as YYYY-MM-DD
													},
												});
											}
										}}
										options={{
											dateFormat: "Y-m-d", // Format of the date
											maxDate: "today", // Minimum date as today
											minDate : memberData?.dob
										}}
										placeholder={t('profile.selectDate')}
										className="form-control" // Optional: Add a CSS class
										ref={flatpickrRef} // Bind Flatpickr to the ref
										/>
										{/* Calendar Icon */}
										<span className="input-group-text input-button" title="toggle"
										onClick={() => flatpickrRef.current.flatpickr.open()}>
											<i className="ri-calendar-line"></i>
										</span>
									</div>
									{error && error.vaccination_date && <span className="required">{error.vaccination_date}</span>}
								</div>
							</div>
							<div className="col-lg-4 col-md-6">
								<div className=" form-group">
									<label>{t('table.age')}</label>
									<select name="age" value={data.age||''} onChange={handleChange} className="form-select">
									<option value="" disabled >{t('common.selectAge')}</option>
									 {vaccinationAgeRanges?.length > 0 && vaccinationAgeRanges?.map(age => (
										<option key={age.id} value={age.id}>{getLocalizedAge(age)}</option>
									  ))}
									</select>
									{error && error.age && <span className="required">{error.age}</span>}
								</div>
							</div>	
						</div>

						<div className="row">
						{allData.map((vaccination, index) => (
							<div key={index} className="col-12">
								<div className="row">
									<div className="col-lg-6 col-md-12">
										<div className="form-group">
											<label>{t('common.vaccinationName')}</label>
											<select
												name="vaccination_name"
												value={vaccination.vaccination_name || ''}
												onChange={(e) => handleChange(e, index)}
												className="form-select"
											>
												<option value="" disabled>{t('common.selectVaccine')}</option>
												{getAvailableVaccinationNames(index).map(item => (
													<option key={item.id} value={item.id}>
														{getLocalizedName(item)}
													</option>
												))}
											</select>
											{/* Display error for vaccination_name */}
											{error && error[`row_${index}`] && error[`row_${index}`].vaccination_name && (
												<span className="required">{error[`row_${index}`].vaccination_name}</span>
											)}
										</div>
									</div>
									{vaccination.vacType === true && (
										<div className="col-lg-6 col-md-12">
										<div className="form-group">
											<label>{t('common.vaccinationType')}</label>
											<select
											name="vaccination_type"
											value={vaccination.vaccination_type || ''}
											onChange={(e) => handleChange(e, index)}
											className="form-select"
											>
											<option value="" disabled>{t('common.selectType')}</option>
											{(vaccination.vacTypeFilter.length > 0 ? vaccination.vacTypeFilter : vaccinationType).map(item => (
												<option key={item.id} value={item.id}>{getLocalizedType(item)}</option>
											))}
											</select>
											{/* Display error for vaccination_type */}
											{error && error[`row_${index}`] && error[`row_${index}`].vaccination_type && (
											<span className="required">{error[`row_${index}`].vaccination_type}</span>
											)}
										</div>
										</div>
									)}
									<div className="row">
										<div className="col-lg-4 col-md-6">
											<div className="form-group">
												<label>{t('common.selectDose')}</label>
												<div className="d-flex align-items-center">
													<div className="ChecksRadios" style={{ backgroundColor: "#f0f4f4", flexGrow: 1 }}>
													{/* Conditional Rendering Logic for Select Dose */}
														{(() => {
															if (vaccination.vacType === true && vaccination.vaccination_name !== '' && vaccination.vaccination_type !== '') {
																// Case 1: vacType is true, both vaccination_name and vaccination_type are selected
																return renderRadioButtons(index);
															} else if (vaccination.vacType === false && vaccination.vaccination_name !== '') {
																// Case 2: vacType is false, and vaccination_name is selected
																return renderRadioButtons(index);
															} else {
																// Case 3: Default radio buttons for doses
																return [...Array(5).keys()].map((doseIndex) => (
																	<div key={doseIndex} className="form-check form-check-inline">
																		<input
																			className={`form-check-input ${role === 4 ? 'admin-form-check-input' : ''}`}
																			type="radio"
																			name={`dose_${index}`}
																			id={`DoseRadio${index}_${doseIndex}`}
																			value={`option${doseIndex + 1}`}
																			disabled={true}
																		/>
																		<label className="form-check-label" htmlFor={`DoseRadio${index}_${doseIndex}`}>
																			{doseIndex}{t('common.tth')}
																		</label>
																	</div>
																));
															}
														})()}
													</div>
				
													<div className="d-inline-flex align-items-center ms-2">
													{/* First row logic */}
													{index === 0 && allData.length === 1 && (
													<button
														type="button"
														className={`btn ${role === 4 ? 'btn-outline-tmAquaDgreen' : 'btn-outline-tmBlue'}`}
														onClick={() => handleAdd(index)}
													>
														<i className="ri-add-fill align-middle"></i>
													</button>
													)}

													{/* Remove button for the first row when there are rows after this one */}
													{index === 0 && allData.length > 1 && (
													<button
														type="button"
														className="btn btn-outline-danger me-2"
														onClick={() => handleRemove(index)}
													>
														<i className="ri-close-fill align-middle"></i>
													</button>
													)}

													{/* In-between row logic (not the first or last row) */}
													{index !== 0 && index !== allData.length - 1 && (
													<button
														type="button"
														className="btn btn-outline-danger me-2"
														onClick={() => handleRemove(index)}
													>
														<i className="ri-close-fill align-middle"></i>
													</button>
													)}

													{/* Last row logic */}
													{index !== 0 && index === allData.length - 1 && index < vaccinationName.length - 1 && (
													<>
														<button
														type="button"
														className="btn btn-outline-danger me-2"
														onClick={() => handleRemove(index)}
														>
														<i className="ri-close-fill align-middle"></i>
														</button>
														<button
														type="button"
														className={`btn ${role === 4 ? 'btn-outline-tmAquaDgreen' : 'btn-outline-tmBlue'}`}
														onClick={() => handleAdd(index)}
														>
														<i className="ri-add-fill align-middle"></i>
														</button>
													</>
													)}

													{/* Last row with maximum limit reached, show only remove */}
													{index !== 0 && index === allData.length - 1 && index >= vaccinationName.length - 1 && (
													<button
														type="button"
														className="btn btn-outline-danger me-2"
														onClick={() => handleRemove(index)}
													>
														<i className="ri-close-fill align-middle"></i>
													</button>
													)}
												</div>

												</div>
												{/* Display error for dose */}
												{error && error[`row_${index}`] && error[`row_${index}`].dose && (
													<span className="required">{error[`row_${index}`].dose}</span>
												)}
											</div>
										</div>
									</div>
								</div>
							</div>
						))}
						</div>

						{/* Button Section */}
						<div className="row">								
							<div className="col-lg-12 text-end">
								<button type="button" className={`btn ${role===4?'btn-tmAquaDgreen':'btn-secondary'} me-2`} onClick={handleCancel}><i className="ri-arrow-left-line align-middle"></i> {t('common.reset')}</button>
								<button type="submit" className={`btn ${role===4?'btn-tmAquaGreen':'btn-tmBlue'}`} onClick={handleSubmit}><i className="ri-check-double-fill align-middle"></i> {t('profile.submit')}</button>
							</div>
						</div>
					</form>
				</div>
			</div>	
		</section>
		{/* End Page Content Section */}
	</main>
	)
}

export default AddVaccination